import { Injectable } from '@angular/core';
import { environment } from '../environment';
import { IEnvironment } from '../types/environment.interface';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private env: IEnvironment = environment;

  /**
   * Get the complete environment configuration
   */
  get config(): IEnvironment {
    return this.env;
  }

  /**
   * Get the API URL
   */
  get apiUrl(): string {
    return this.env.apiUrl;
  }

  /**
   * Get the application name
   */
  get appName(): string {
    return this.env.appName;
  }

  /**
   * Get the application version
   */
  get version(): string {
    return this.env.version;
  }

  /**
   * Check if running in production mode
   */
  get isProduction(): boolean {
    return this.env.production;
  }

  /**
   * Check if running in development mode
   */
  get isDevelopment(): boolean {
    return !this.env.production;
  }

  /**
   * Check if debug mode is enabled
   */
  get isDebugMode(): boolean {
    return this.env.debug;
  }

  /**
   * Check if logging is enabled
   */
  get isLoggingEnabled(): boolean {
    return this.env.enableLogging;
  }

  /**
   * Get the current log level
   */
  get logLevel(): string {
    return this.env.logLevel;
  }

  /**
   * Get the current environment name
   */
  get environment(): string {
    return this.env.environment || 'dev';
  }


  get profile(): string | undefined {
    return this.env.profile;
  }

  /**
   * Get the request timeout
   */
  get timeout(): number {
    return this.env.timeout || 30000;
  }

  /**
   * Check if a specific feature is enabled
   */
  isFeatureEnabled(feature: string): boolean {
    return this.env.features[feature] || false;
  }

  /**
   * Check if running in a specific environment
   */
  isEnvironment(env: string): boolean {
    return this.env.environment === env;
  }


  isProfile(name: string): boolean {
    return this.env.profile === name;
  }

  /**
   * Get all enabled features
   */
  getEnabledFeatures(): string[] {
    return Object.keys(this.env.features).filter(feature => this.env.features[feature]);
  }


}
